export default [
  { name: "small", width: 360, height: 640 },
  { name: "medium", width: 1024, height: 768 },
  { name: "large", width: 1440, height: 900 },
  { name: "xlarge", width: 1920, height: 1080 }
];
